import React, { useContext, useEffect } from 'react';
import { P2GProgress } from '@parcel2go/peacock-legacy-core/dist/progress';
import { NotificationContext } from './services/contexts/NotificationContext';
import {
  AccountLinkingMessageHelper,
  AccountLinkingResponseHelper,
} from './services/helpers/AccountLinkingResponseHelper';
import { CreateUniqueId } from './services/helpers/Identifiers';
import { Integration } from './services/api/types';
import { GetAccountNotifications } from './components/GetAccountNotifications';

interface props {
  integrations: Integration[];
}

const AppTaskWrapper: React.FC<props> = (props) => {
  const notificationsContext = useContext(NotificationContext);
  const [loading, setLoading] = React.useState<boolean>(true);

  // OnPageLoad
  useEffect(() => {
    var resp = AccountLinkingResponseHelper(document.location.href);
    if (resp.actionableAction) {
      var uid = resp.accountId ? `${resp.accountId}:${resp.action}` : CreateUniqueId();
      notificationsContext.dispatch({
        type: 'ADD',
        payload: {
          color: resp.success ? 'success' : 'error',
          note: AccountLinkingMessageHelper(resp.action, resp.success),
          id: uid,
          status: resp.accountStatus,
          integrationSlug: resp.slug,
          integrationType: resp.integrationType,
          accountId: resp.accountId,
          actions: [],
          showClose: true,
          success: resp.success,
          action: resp.action,
          configRequired: false,
        },
      });
      // Remove Query Params
      window.history.pushState({}, document.title, window.location.pathname);
    }
  }, []);

  // OnAccountIntergration
  useEffect(() => {
    if (!loading || !props.integrations) {
      return;
    }

    // Get all the account notifications to show, on successful api call from integrations
    GetAccountNotifications(props.integrations).forEach((n) => {
      notificationsContext.dispatch({
        type: 'ADD',
        payload: n,
      });
    });

    setLoading(false);
  }, [loading, props.integrations]);

  if (loading) {
    return <P2GProgress />;
  }

  return <>{props.children}</>;
};

export default AppTaskWrapper;
